<template>
  <div class="component component--fullscreen" v-if="visible">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>

    <transition name="modal">
      <div class="component__container" v-if="componentVisible" v-body-scroll-lock="visible">
        <div class="vip-navigation">
          <div class="vip-navigation__header">
            <div class="title">{{ title }}</div>
            <button class="toggle" v-on:click="onClose()">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="vip-navigation__body">
            <div class="menu-items">
              <div v-for="item in items" :key="item.icon" class="menu-items__item">
                <div class="menu-items__avatar">
                  <span class="menu-items__icon">
                    <slot :icon="item.icon">
                      <i class="material-icons">{{ item.icon }}</i>
                    </slot>
                  </span>
                  <span v-if="item.icon === 'inventory' && badgeCount > 0" class="menu-items__badge">{{ badgeCount }}</span>
                </div>
                <!-- 選單名稱 -->
                <div class="menu-items__label" v-on:click="$emit('clickItem', item.icon)">
                  {{ $t(item.label) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'VipNavigation',
  props: {
    /**
     * 雙向綁定值 (關閉狀態)
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * 標題名稱
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * 選單清單
     *
     * @summary
     * 支援屬性: icon, label
     */
    items: {
      type: Array,
      default: () => [],
      validator(value) {
        return value.every(item => item.icon && item.label);
      },
    },
    /**
     * Badge 計數顯示
     */
    badgeCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    /**
     * 是否顯示彈窗
     */
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      componentVisible: false,
    };
  },
  watch: {
    value(val) {
      this.$nextTick(() => {
        this.componentVisible = val;
      });
    },
  },
  methods: {
    /**
     * 關閉彈窗
     */
    onClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  transition: all 0.25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: 0.7
  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__container
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1050
  margin: 0 auto
  overflow: auto
  display: flex
  flex-direction: column-reverse
  -webkit-overflow-scrolling: touch

  @media only screen and (min-width : 768px)
    max-width: 500px
    flex-direction: column
    justify-content: center

.vip-navigation
  border-top-left-radius: 16px
  border-top-right-radius: 16px
  background-color: #FFFFFF
  padding: 12px 0

  @media only screen and (min-width : 768px)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px

  &__header
    position: sticky
    top: 0
    z-index: 1020
    display: flex
    align-items: center

    .title
      flex-grow: 1
      font-weight: 700
      font-size: 1rem
      text-align: center
      line-height: 40px

    .toggle
      position: absolute
      top: 0
      right: 12px
      padding: 8px
      width: 40px
      height: 40px
      border: none
      border-radius: 12px
      background-color: #F1F1F1
      color: #909090
      outline: none

      &:active
        color: #333333

  &__body
    .menu-items
      padding: 0 0 12px 16px

      &__item
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-wrap: wrap;
        padding: 16px 0
        gap: 0px 16px

        &:not(:last-child)
          &::after
            content: ''
            position: absolute
            bottom: 0
            left: 64px
            right: 0
            height: 0.5px
            background-color: rgba(142, 142, 142, 0.25)

      &__avatar
        position: relative

      &__icon
        width: 48px
        height: 48px
        padding: 12px
        background-color: #F1F1F1
        border-radius: 48px
        overflow: hidden
        display: inline-block
        vertical-align: middle
        text-align: center

        .material-icons
          width: 24px
          height: 24px
          color: #BDBDBD

      &__badge
        position: absolute
        bottom: 0
        right: 0
        width: 20px
        height: 20px
        border-radius: 20px
        color: #ffffff
        font-size: 12px
        font-weight: 600
        text-align: center
        line-height: 20px
        background-color: #FF3049

      &__label
        flex: 1
        color: #3A3A3A
        font-size: 1rem
        font-weight: 600
        line-height: 48px
        cursor: pointer
        user-select: none

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.modal-enter-active,
.modal-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1), transform .15s cubic-bezier(.4, 0, .2, 1)

.modal-enter,
.modal-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
